import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { siteSettings } from "@/content/site";
import { Phone, EnvelopeSimple, MapPin, WhatsappLogo, ArrowRight } from "@phosphor-icons/react";

export default function Contatti() {
  const wa = siteSettings.whatsapp_number?.replace(/[^\d]/g, "");
  return (
    <div className="bg-warm-white min-h-screen">
      <Navbar />
      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-5 md:px-10">
          <div className="overline mb-4">Contatti</div>
          <h1 className="font-display text-4xl md:text-6xl leading-tight mb-5">Parliamo del tuo bagno.</h1>
          <p className="text-[#5C5C59] text-base md:text-lg max-w-2xl">Per qualsiasi informazione puoi contattarci o direttamente richiedere un sopralluogo gratuito.</p>

          <div className="mt-12 grid md:grid-cols-3 gap-5">
            <div className="card-soft p-6">
              <Phone size={22} weight="light" className="text-oasi-green mb-3" />
              <div className="overline mb-1">Telefono</div>
              <div className="text-anthracite">{siteSettings.phone}</div>
            </div>
            <div className="card-soft p-6">
              <EnvelopeSimple size={22} weight="light" className="text-oasi-green mb-3" />
              <div className="overline mb-1">Email</div>
              <div className="text-anthracite">{siteSettings.notification_email}</div>
            </div>
            <div className="card-soft p-6">
              <MapPin size={22} weight="light" className="text-oasi-green mb-3" />
              <div className="overline mb-1">Sede</div>
              <div className="text-anthracite">{siteSettings.address}</div>
              <div className="text-xs text-[#5C5C59] mt-2">{siteSettings.served_areas}</div>
            </div>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/prenota-sopralluogo" className="btn-primary inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full text-sm">
              Richiedi sopralluogo gratuito <ArrowRight size={16} />
            </Link>
            {wa && (
              <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="btn-outline inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full text-sm">
                <WhatsappLogo size={18} weight="fill" /> Scrivici su WhatsApp
              </a>
            )}
          </div>
        </div>
      </section>
      <Footer settings={siteSettings} />
      <WhatsAppFloat number={siteSettings.whatsapp_number} />
    </div>
  );
}
